import { ModernWebLayout } from "../../components/Layout";
import DrugIndicationList from "./DrugIndicationList";
import style from "./DrugOverviewPage.module.scss";

const DrugOverviewPage = () => {
  return (
    <ModernWebLayout>
      <div className={style.drugOverviewPage}>
        <DrugIndicationList></DrugIndicationList>
      </div>
    </ModernWebLayout>
  );
};

export default DrugOverviewPage;
